const sortPricesByDays = (prices: {minDays: number; amount: number;}[]) => {
  return prices.sort((a, b) => {
    if (a.minDays > b.minDays) {
      return 1;
    } else if (a.minDays < b.minDays) {
      return -1;
    }

    return 0;

  });
};

export { sortPricesByDays };
